// extracted by mini-css-extract-plugin
module.exports = {"container":"ThemeSwitcher_container__IQFzm","customToggle":"ThemeSwitcher_customToggle__ABlwn"};